// extracted by mini-css-extract-plugin
export var copyableField = "_rn-4";
export var customerBadge = "_rn-0";
export var customerInfoTitle = "_rn-2";
export var details = "_rn-1";
export var dropdownContainer = "_rn-5";
export var dropdownImage = "_rn-6";
export var editAssigneeForm = "_rn-a";
export var editButton = "_rn-3";
export var email = "_rn-7";
export var hidden = "_rn-d";
export var input = "_rn-8";
export var saveButton = "_rn-b";
export var shopifyIcon = "_rn-c";
export var suggestionBadge = "_rn-e";
export var suggestionText = "_rn-f";
export var username = "_rn-9";